export default {
  name: 'Header',
  data() {
    return {
      backgrounds: {
        "default": '/img/topwszech/ogolny.jpg',
        "23": '/img/topwszech/23.jpg',
        "24": '/img/topwszech/24.jpg',
        "25": '/img/topwszech/25.jpg',
        "26": '/img/topwszech/26.jpg'
      }
    }
  },
  methods: {
    chooseBackground(key) {
      if(this.backgrounds[key]) {
        return this.backgrounds[key];
      } else {
        return this.backgrounds["default"];
      }
    },
    showTopNumber(key) {
      if(this.backgrounds[key]) {
        return false
      }
      return true
    }
  },
  computed: {
    modal() {
      return this.$store.state.loginModal;
    },
    topNumber() {
        return this.$store.state.topWszech;
    },
    searchActive() {
      return this.$store.state.searchActive;
    }
  }
}
